// Thư mục: src/services/checklistService.js
import api from "@/api";

const BASE_URL = "/api/checklist";

export const ChecklistApi = {
  /**
   * Lấy danh sách hạng mục checklist cho xe
   * @param {number} xeId - ID của xe đang được phân công
   * @returns {Promise<Array<object>>} List<ChecklistItemDto>
   */
  getHangMuc(xeId) {
    return api
      .get(`${BASE_URL}/hang-muc-cho-xe`, { params: { xeId } })
      .then((res) => res.data);
  },

  /**
   * Nộp kết quả checklist
   * @param {object} payload - ChecklistSubmitRequest { xeId, odo, items: [...] }
   * @returns {Promise<object>} ChecklistSubmitResponse { logId, hasCriticalError }
   */
  submit(payload) {
    return api.post(`${BASE_URL}/submit`, payload).then((res) => res.data);
  },

  // (Em cần thêm service upload ảnh, ví dụ: fileService.upload(formData))
};
